import React from 'react';
import {
  X, MonitorDown, Lock, Minimize2, ArrowLeftRight,
  FolderOpen, Play, LayoutGrid, Search, Settings,
  Clipboard, Monitor, Camera, ListTodo, XCircle, Maximize, Unlock
} from 'lucide-react';

interface QuickActionsProps {
  onClose: () => void;
  onAction: (action: string) => void;
}

interface ActionButtonProps {
  label: string;
  icon?: React.ReactNode;
  onClick: () => void;
}

const ActionButton: React.FC<ActionButtonProps> = ({ label, icon, onClick }) => (
  <button
    onClick={onClick}
    className="px-2.5 py-1.5 rounded-lg hover:bg-white/10 text-[10px] font-medium text-zinc-300 hover:text-white transition-all flex items-center gap-1.5 active:scale-95 whitespace-nowrap"
  >
    {icon}
    {label}
  </button>
);

const Divider = () => <div className="w-px h-4 bg-white/10 mx-0.5" />;

const QuickActions: React.FC<QuickActionsProps> = ({ onClose, onAction }) => {
  // 系统操作
  const systemActions = [
    { label: 'Ctrl+Alt+Del', key: 'ctrl+alt+del', icon: <Lock size={12} /> },
    { label: '解锁', key: 'unlock', icon: <Unlock size={12} /> },
    { label: 'Win+L 锁屏', key: 'win+l', icon: <Lock size={12} /> },
    { label: 'Ctrl+Shift+Esc', key: 'ctrl+shift+esc', icon: <ListTodo size={12} /> },
  ];

  // 窗口操作
  const windowActions = [
    { label: 'Alt+Tab', key: 'alt+tab', icon: <ArrowLeftRight size={12} /> },
    { label: 'Win+Tab', key: 'win+tab', icon: <LayoutGrid size={12} /> },
    { label: 'Win+D 桌面', key: 'win+d', icon: <Minimize2 size={12} /> },
    { label: 'Alt+F4 关闭', key: 'alt+f4', icon: <XCircle size={12} /> },
    { label: 'F11 全屏', key: 'f11', icon: <Maximize size={12} /> },
  ];

  // 工具操作
  const toolActions = [
    { label: 'Win+E 资源管理器', key: 'win+e', icon: <FolderOpen size={12} /> },
    { label: 'Win+R 运行', key: 'win+r', icon: <Play size={12} /> },
    { label: 'Win+S 搜索', key: 'win+s', icon: <Search size={12} /> },
    { label: 'Win+I 设置', key: 'win+i', icon: <Settings size={12} /> },
    { label: 'Win+V 剪贴板', key: 'win+v', icon: <Clipboard size={12} /> },
    { label: 'Win+P 投影', key: 'win+p', icon: <Monitor size={12} /> },
    { label: 'Win+Shift+S 截图', key: 'win+shift+s', icon: <Camera size={12} /> },
  ];

  // 其他
  const otherActions = [
    { label: '刷新画面', key: 'refresh', icon: <MonitorDown size={12} /> },
  ];

  return (
    <div className="fixed top-24 left-0 right-0 z-[60] flex justify-center px-4">
      <div className="animate-slide-down glass-high p-1.5 rounded-2xl flex flex-wrap items-center gap-0.5 border border-white/10 shadow-3xl max-w-[95vw]">
        {/* 系统 */}
        {systemActions.map((action) => (
          <ActionButton key={action.key} label={action.label} icon={action.icon} onClick={() => onAction(action.key)} />
        ))}
        <Divider />
        {/* 窗口 */}
        {windowActions.map((action) => (
          <ActionButton key={action.key} label={action.label} icon={action.icon} onClick={() => onAction(action.key)} />
        ))}
        <Divider />
        {/* 工具 */}
        {toolActions.map((action) => (
          <ActionButton key={action.key} label={action.label} icon={action.icon} onClick={() => onAction(action.key)} />
        ))}
        <Divider />
        {/* 其他 */}
        {otherActions.map((action) => (
          <ActionButton key={action.key} label={action.label} icon={action.icon} onClick={() => onAction(action.key)} />
        ))}
        <Divider />
        <button
          onClick={onClose}
          className="p-1.5 hover:bg-red-500/20 text-zinc-500 hover:text-red-500 rounded-lg transition-colors"
        >
          <X size={14} />
        </button>
      </div>
    </div>
  );
};

export default React.memo(QuickActions);
